import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { useCookieState } from 'use-cookie-state'

import { Button, ButtonProps } from '@blueprintjs/core'
import { DARK } from '@blueprintjs/core/lib/esm/common/classes'
import { IconNames } from '@blueprintjs/icons'

import styles from './ThemeButton.module.scss'

export default (props: ButtonProps) => {
    const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark" : "light"
    const [theme, setTheme] = useCookieState<"light" | "dark">("theme", systemTheme)
    const { t } = useTranslation()

    return <>
        {theme === "dark" && <>
            <Helmet bodyAttributes={{ class: theme === 'dark' ? DARK : '' }} />
        </>}

        {!props.hidden && <>
            <Button
                {...props}
                className={styles.darkButton}
                text={t("themeButton.label.dark")}
                icon={IconNames.Moon}
                onClick={() => setTheme("light")}
            />

            <Button
                {...props}
                className={styles.lightButton}
                text={t("themeButton.label.light")}
                icon={IconNames.Flash}
                onClick={() => setTheme("dark")}
            />
        </>}
    </>
}